var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppConfiguration } from '../Config';
import Cookies from 'js-cookie';
import { AuthenticatedApi } from './Core/AuthenticatedApi';
export class MakhazinAuthApi extends AuthenticatedApi {
    constructor(accessToken, refreshToken, handleRefreshedToken, logout, impersonatedAs) {
        super(accessToken, getAppConfiguration().makhazinApi, impersonatedAs);
        this.logout = () => {
            logout();
        };
        this.handleUnauthenticated = this.tryRefreshToken;
        this.refreshToken = refreshToken;
        this.handleRefreshedToken = handleRefreshedToken;
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get('/authentication');
            return result;
        });
    }
    getRentals() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get('/subscriptions/rentals');
            if (result === null) {
                return null;
            }
            return result;
        });
    }
    tryRefreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const refreshingToken = window['refreshingToken'];
                if (refreshingToken) {
                    return true;
                }
                if (!Cookies.get('accessToken') || !Cookies.get('refreshToken')) {
                    this.logout();
                    return false;
                }
                window['refreshingToken'] = true;
                const result = yield this.post('/authentication/refresh', {
                    accessToken: Cookies.get('accessToken'),
                    refreshToken: Cookies.get('refreshToken'),
                });
                if (result) {
                    this.handleRefreshedToken(result.accessToken, result.refreshToken);
                }
            }
            catch (exception) {
                this.logout();
                return false;
            }
            window['refreshingToken'] = false;
            return true;
        });
    }
    editProfile(user) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.put('/profile', user, true);
        });
    }
    changePassword(form) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/profile/password-change`, form, true);
        });
    }
    initEmailVerification() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post('/profile/init-email-verification', undefined, true);
        });
    }
    getPaymentMethod() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/profile/payment-method`);
            return result;
        });
    }
    initChangePaymentMethod() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post('/profile/init-change-payment-method', undefined, true);
            const result = yield this.post(`/profile/init-change-payment-method`);
            return result;
        });
    }
    getActivities(storageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/storage/${storageId}/activity`);
            return result;
        });
    }
    getStorageInfo(storageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get('/subscriptions/mystorage', {
                storageId: storageId,
            });
            return result;
        });
    }
    unlockStorage(storageId, unlock) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/storage/${storageId}/unlock?unlock=${unlock}`, undefined, true);
            return;
        });
    }
    turnOnLight(storageId, on) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/storage/${storageId}/turn-on-light?on=${on}`, undefined, true);
            return;
        });
    }
    cancelSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.delete(`/subscriptions?subscriptionId=${subscriptionId}`);
            return;
        });
    }
    getStorageUsers(storageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/storage/${storageId}/users`);
            return result;
        });
    }
    inviteStorageUser(storageId, email) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/storage/${storageId}/users/invite?email=${email}`, null, true);
            return;
        });
    }
    deleteStorageUser(storageId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.delete(`/storage/${storageId}/users/${userId}`, null, true);
            return;
        });
    }
    deleteStorageUserInvitation(storageId, userInvitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.delete(`/storage/${storageId}/users/invitations/${userInvitationId}`, null, true);
            return;
        });
    }
    getReceipt(transactionNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/payments/${transactionNumber}`);
            return result;
        });
    }
    getPayments() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get('/payments');
            return result;
        });
    }
}
